module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1509-08fc1e9e24b592a4e67a264d81cc83bc.png";